import { render, staticRenderFns } from "./EditInventoryItemCatalogDrawer.vue?vue&type=template&id=c866f52e"
import script from "./EditInventoryItemCatalogDrawer.vue?vue&type=script&lang=js"
export * from "./EditInventoryItemCatalogDrawer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports